import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AssetBasketService } from '@thehubz/client/asset-services';
import { CommonUtilityLib, NavigationItem } from '@thehubz/client/core';
import { filter } from 'rxjs';

@Component({
  selector: 'thehubz-menu-sub-items',
  templateUrl: './menu-sub-items.component.html',
  styleUrls: ['./menu-sub-items.component.scss'],
})
export class MenuSubItemsComponent implements OnInit {
  @Input() subMenuItemList: NavigationItem[] | undefined;

  selectedIndex = 0;
  currentURL = '';

  constructor(private commonUtilityLib: CommonUtilityLib, private router: Router, protected assetBasketService: AssetBasketService) {}

  ngOnInit(): void {
    const obj: any = this.commonUtilityLib.routingObjectGetter();
    const index = this.subMenuItemList?.findIndex((x) => x.key == obj.key);
    if (index && index != -1) this.selectedIndex = index;
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.checkRoute();
    });
    this.checkRoute();
  }

  checkRoute() {
    this.currentURL = this.router.url.split('?')[0];
    if (this.currentURL === '/login') return;
    for (let nav = 0; nav < (this.subMenuItemList || []).length; nav++) {
      if (this.subMenuItemList && this.subMenuItemList[nav]) {
        const matchURL = '/' + this.subMenuItemList[nav].routerLink;
        if (this.currentURL === matchURL) {
          this.selectedIndex = nav;
          break;
        }
        // Todo (Look for better solution): '/detail' is hard coded
        // Added for selecting project and task from dashboard.
        // As selectedIndex is not getting proper value for projects/detail/:id/project-overview
        if (this.currentURL.includes(matchURL + '/detail') || matchURL.includes('/collections')) {
          this.selectedIndex = nav;
          break;
        }
      }
    }
  }

  setRouterObject(data: any) {
    this.commonUtilityLib.routingObjectSetter(data);
  }
}
